package com.milta.core.localization

data class AuthStrings(
    // Shared
    val login: String,
    val logout: String,
    val email: String,
    val password: String,
    val showPassword: String,
    val hidePassword: String,
    // Role selection
    val roleSelectionTitle: String,
    val roleSelectionSubtitle: String,
    val roleDriverTitle: String,
    val roleDriverDescription: String,
    val roleDriverTag1: String,
    val roleDriverTag2: String,
    val roleEnterpriseTitle: String,
    val roleEnterpriseDescription: String,
    val roleEnterpriseTag1: String,
    val roleEnterpriseTag2: String,
    val continueButton: String,
    // Register form
    val registerFormTitle: String,
    val registerFormSubtitle: String,
    val registerFormSubtitleEnterprise: String,
    val googleAccountConnected: String,
    val appleAccountConnected: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val phoneNumberHelper: String,
    val phoneNumberOtpInfo: String,
    val registerButton: String,
    val passwordHint: String,
    val registerSuccess: String,
    val errorEmailConflict: String,
    val errorPhoneConflict: String,
    val errorGeneric: String,
    val errorFirstNameRequired: String,
    val errorFirstNameTooLong: String,
    val errorLastNameRequired: String,
    val errorLastNameTooLong: String,
    val errorPhoneTooLong: String,
    val errorOAuthAccountExists: String,
    val errorOAuthTokenInvalid: String,
    // Login
    val loginTitle: String,
    val loginTabPassword: String,
    val loginTabPhone: String,
    val loginButton: String,
    val forgotPassword: String,
    val sendCodeButton: String,
    // OTP
    val otpTitle: String,
    val otpSubtitle: String,
    val otpVerifyButton: String,
    val otpResend: String,
    val otpResendPrefix: String,
    val otpWrongNumber: String,
    val otpModifyLink: String,
    // Forgot password
    val forgotPasswordTitle: String,
    val forgotPasswordSubtitle: String,
    val forgotPasswordButton: String,
    val forgotPasswordSuccess: String,
    // Reset password
    val resetPasswordTitle: String,
    val resetPasswordSubtitle: String,
    val resetPasswordNewLabel: String,
    val resetPasswordConfirmLabel: String,
    val resetPasswordButton: String,
    val resetPasswordSuccess: String,
    val errorPasswordTooShort: String,
    val errorPasswordTooLong: String,
    val errorPasswordMismatch: String,
    val errorTokenInvalid: String,
    // Error messages
    val errorEmailInvalid: String,
    val errorPhoneRequired: String,
    val errorInvalidCredentials: String,
    val errorInvalidOtp: String,
    val errorExpiredOtp: String,
    val errorTooManyAttempts: String,
    val errorResendLimit: String,
    // OTP helpers
    val otpResendIn: String,
    val otpAttemptsLeft: String,
    // Login redesign
    val loginGreeting: String,
    val loginSubtitle: String,
    val loginSmsOption: String,
    val noAccount: String,
    val signUp: String,
    // Register multi-step
    val organizationName: String,
    val organizationNameRequired: String,
    val registerNextButton: String,
    val passwordConfirm: String,
    val passwordRuleUpper: String,
    val passwordRuleDigit: String,
    val passwordRuleSpecial: String,
    val alreadyHaveAccount: String,
)
